import Column from '@app/components/layout/Column'
import { Style } from 'inlines'
import { ReactNode, Fragment } from 'react'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { HorizontalSeparator } from '@app/components/core/separator/HorizontalSeparator'

export interface DetailsPanelItem {
  label: string
  value: ReactNode
}

export interface DetailsPanelProps {
  items: DetailsPanelItem[]
  style?: Style
}

export const DetailsPanel = ({ items, style }: DetailsPanelProps) => {
  return (
    <Column gap="1rem" style={{ ...style }}>
      {items.map((item) => (
        <Fragment key={`${item.label}-details-panel-item`}>
          <div>
            <Title.H5 style={{ marginBottom: '0.5rem' }}>{item.label}</Title.H5>
            <Text.Medium>{item.value}</Text.Medium>
          </div>
          <HorizontalSeparator />
        </Fragment>
      ))}
    </Column>
  )
}
